import React, { useEffect, useState } from 'react';
import { AgentCardHolder } from './AgentsSection.styles';
import agentService from '../../services/agentService';
import Loaders from '../Loaders';
import AgentCard from '../AgentCard';
import Select from '../Select';
import { useQuery } from '@tanstack/react-query';
import Field from '../Field';

const FeedaAgents = () => {
  const [query, setQuery] = useState('');
  const [filterName, setFilterName] = useState(null);
  const [agentsCategory, setAgentsCategory] = useState([]);
  const GetFeedaAgents = useQuery({
    queryKey: ['get-feeda-agents', query],
    queryFn: () => agentService.getAllfeedaAgents(query),
  });
  const getFeedaCategory = async () => {
    const resp = await agentService.getAllfeedaAgentsCategory('admin_created');
    const restructuredDataForSelect = resp?.domains?.map(elem => ({ label: elem?.domain, value: elem?.domain_id }));
    setAgentsCategory([{ label: 'All', value: '' }, ...restructuredDataForSelect]);
  };
  useEffect(() => {
    getFeedaCategory();
  }, []);

  return (
    <>
      <div className="inputs-wrapper">
        <div className="select-wrapper">
          <Select
            options={agentsCategory}
            placeholder="All"
            onChange={({ target }) => setQuery(target?.value?.value)}
          />
        </div>
        <Field
          type="text"
          placeholder="Search agent by name"
          name="searchAgent"
          onChange={({ target }) => setFilterName(target?.value)}
        />
      </div>

      <AgentCardHolder>
        {GetFeedaAgents?.isPending ? (
          <Loaders viewLoader />
        ) : (
          <AgentCard agentCardsData={GetFeedaAgents?.data?.agents} filterName={filterName} removeDuplicate />
        )}
      </AgentCardHolder>
    </>
  );
};

export default FeedaAgents;
